import { SEO_LANGS, buildAlternateLinks, getSiteUrl, replaceLangInPath } from '@/utils/seo'

export default {
  metaInfo() {
    const routePath = this.$route?.path
    const canonicalPath = typeof this.getSeoCanonicalPath === 'function'
      ? this.getSeoCanonicalPath()
      : routePath

    if (!canonicalPath) {
      return {}
    }

    const siteUrl = getSiteUrl()
    const segments = canonicalPath.split('/').filter(Boolean)
    const isLocalizedRoute = canonicalPath === '/' || (segments.length > 0 && SEO_LANGS.includes(segments[0]))
    const pathByLang = isLocalizedRoute
      ? (typeof this.getSeoAlternatePaths === 'function'
          ? this.getSeoAlternatePaths()
          : SEO_LANGS.reduce((acc, lang) => {
              acc[lang] = replaceLangInPath(canonicalPath, lang)
              return acc
            }, {}))
      : null
    return {
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: `${siteUrl}${canonicalPath}`,
        },
        ...buildAlternateLinks(pathByLang, siteUrl),
      ],
    }
  },
}
